import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import { MainWrapper, SectionHeader } from "components"
import { CardWrapper, FeaturesWrapper, MainContent } from "./styles"
import { Card } from "./Card"
import background from "../../images/green-back.jpeg"

export const Special = () => {
  return (
    <FeaturesWrapper background={background} id="special-menu">
      <MainContent>
        <MainWrapper>
          <SectionHeader title="Special Menu" />
          <CardWrapper>
            <Card
              title="Cocido"
              description="'Our Famous Cocido'. Specially selected short ribs cooked to enhance your appetite with zucchini, green beans, potatoes, garbanzos, carrots, cilantro and corn. Served with rice, beans and tortillas."
              delay="150"
            >
              <StaticImage
                imgStyle={{ borderRadius: "50%" }}
                src="../../images/cocido.jpeg"
                alt="Cocido"
              />
            </Card>
            <Card
              title="Fajitas"
              description="Beef, chicken, or seafood fajitas."
              delay="200"
            >
              <StaticImage
                imgStyle={{ borderRadius: "50%" }}
                src="../../images/fajitas.jpeg"
                alt="Fajitas"
              />
            </Card>
            <Card
              title="Margaritas"
              description="Full bar available."
              delay="250"
            >
              <StaticImage
                imgStyle={{ borderRadius: "50%" }}
                src="../../images/margaitas.jpeg"
                alt="Margaitas"
              />
            </Card>
            <Card
              title="Guacamole"
              description="Freshly made guacamole."
              delay="250"
            >
              <StaticImage
                imgStyle={{ borderRadius: "50%" }}
                src="../../images/guacamole.jpeg"
                alt="Guacamole"
              />
            </Card>
            <Card
              title="Sopas"
              description="Soft handmade corn tortilla(3) dipped in chili, filled with selection of beef, chicken or chorizo, beans and lettuce, topped with tomato sauce, sliced onion, olives and grated cheese."
              delay="300"
            >
              <StaticImage
                imgStyle={{ borderRadius: "50%" }}
                src="../../images/sopas.jpeg"
                alt="Sopas"
              />
            </Card>
            <Card
              title="Desert"
              description="A section of delicious Mexican inspired deserts."
              delay="350"
            >
              <StaticImage
                imgStyle={{ borderRadius: "50%" }}
                src="../../images/desert.jpeg"
                alt="Desert"
              />
            </Card>
          </CardWrapper>
        </MainWrapper>
      </MainContent>
    </FeaturesWrapper>
  )
}
